import {
  isArray
} from 'lodash-es'

import axios from '@util/axios'

export const LincolnGlobalUMRService = {
  list: (role, role_value, params = {}, options = {}) => {
    const query = Object.entries(params)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        if (!isArray(value)) return `${key}=${value}`

        return value.map((v) => `${key}=${v}`).join('&')
      })
      .join('&')

    return axios({
      ...options,
      url: `/lincoln/global-umr/list/?${query}`,
      params: {
        role,
        role_value
      }
    })
  },
  listInactive: (role, role_value, params = {}, options = {}) => {
    const query = Object.entries(params)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        if (!isArray(value)) return `${key}=${value}`

        return value.map((v) => `${key}=${v}`).join('&')
      })
      .join('&')

    return axios({
      ...options,
      url: `/lincoln/global-umr/list/bdx-status-pending/?${query}`,
      params: {
        role,
        role_value
      }
    })
  },
  update: (formData, options = {}) =>
    axios({
      ...options,
      url: `/lincoln/global-umr/update/`,
      method: 'PUT',
      data: formData
    }),
  // LIQ-2410: Account Names for a UMR (cash books + names already on keys)
  accountNames: (umr, options = {}) =>
    axios({
      ...options,
      url: `/lincoln/global-umr/account-names/`,
      params: {
        umr
      }
    }),
  bulkUpdate: (formData, options = {}) =>
    axios({
      ...options,
      url: `/lincoln/global-umr/bulk/update/`,
      method: 'PUT',
      data: formData
    }),
  updateStatus: (
      user_email,
      statuses_list = [],
      pending_section = false,
      options = {}
    ) =>
    axios({
      ...options,
      url: `/lincoln/global-umr/status-update/`,
      method: 'PUT',
      data: {
        user_email,
        data: statuses_list,
        pending_section
      }
    }),
  exportInactive: (role, role_value, email, params = {}, options = {}) => {
    const query = Object.entries(params)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        if (!isArray(value)) return `${key}=${value}`

        return value.map((v) => `${key}=${v}`).join('&')
      })
      .join('&')

    return axios({
      ...options,
      url: `/lincoln/bdx-status-pending-export/?${query}`,
      params: {
        role,
        role_value,
        email
      }
    })
  },
  exportPreview: (umrRcCcSn, email, options = {}) =>
    axios({
      ...options,
      url: `/lincoln/bdx-status-pending-preview-export/`,
      params: {
        umr_rc_cc_sn: umrRcCcSn,
        email
      }
    }),

  getBdxFullPreview: async (data = {}) =>
    axios({
      url: '/bdx/full-preview/',
      method: 'POST',
      data
    }),
  uploadFile: (formData, options = {}) =>
    axios({
      ...options,
      url: `/file/upload/`,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    })
}
